<template>
  <div class="spacer"/>
</template>

<script>
export default {
  name: 'FlexSpacer',
}
</script>

<style scoped>
.spacer {
  flex-grow: 1;
  height: 0;
}
</style>
